import {useViewerStore} from "../store/store";

export const getPathnameIncludes = (pathname: string) => {
    return useViewerStore.getState().pathname.includes(pathname);
}

export const getPathname = () => {
    return useViewerStore.getState().pathname;
}